import { gql } from '@apollo/client';

export const CREATE_ACTIVITY_MUTATION = gql`
  mutation createActivity(
    $entityType: String!
    $entityId: Int!
    $action: String!
  ) {
    createActivity(
      entityType: $entityType
      entityId: $entityId
      action: $action
    ) {
      activity {
        id
        userId
        userName
        entityId
        entityType
        action
        createdAt
      }
    }
  }
`;
